import styled from 'styled-components'

const Card = styled.div`
  box-shadow: 0 0 8px 2px rgba(100, 100, 100, 0.25);
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  margin: 5px;
  background: white;
`

export default Card
